var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders } from "../utils/apiUtils";
import { agencyPublishersIdGenericProductNumbers } from "../types/apiPaths";
import { fetchAllPages, MAX_LIST_LIMIT } from "../utils/fetchAllPages";
export var fetchAgencyPublishers = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, filters) {
        var query, _a, offset, _b, limit, baseQuery, searchParams, response, error_1;
        if (filters === void 0) { filters = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    query = filters.query, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? MAX_LIST_LIMIT : _b;
                    baseQuery = query || "cql.allRecords=1";
                    searchParams = new URLSearchParams();
                    searchParams.set("query", "".concat(baseQuery, " sortBy status name"));
                    searchParams.set("offset", String(offset));
                    searchParams.set("limit", String(limit));
                    return [4 /*yield*/, kyInstance.get("agency-publishers", {
                            searchParams: searchParams,
                            headers: getHeaders(),
                        })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error("Fetch publishers error: ".concat(response.statusText));
                    }
                    return [2 /*return*/, response.json()];
                case 2:
                    error_1 = _c.sent();
                    console.error("Fetch publishers error:", error_1);
                    return [2 /*return*/, { items: [], totalRecords: 0 }];
                case 3: return [2 /*return*/];
            }
        });
    });
};
export var searchAgencyPublishers = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, filters) {
        var query, _a, offset, _b, limit, baseQuery, searchParams, response, error_2;
        if (filters === void 0) { filters = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    query = filters.query, _a = filters.offset, offset = _a === void 0 ? 0 : _a, _b = filters.limit, limit = _b === void 0 ? MAX_LIST_LIMIT : _b;
                    baseQuery = query || "cql.allRecords=1";
                    searchParams = new URLSearchParams();
                    searchParams.set("query", "".concat(baseQuery, " sortBy status name"));
                    searchParams.set("offset", String(offset));
                    searchParams.set("limit", String(limit));
                    return [4 /*yield*/, kyInstance.get("agency-publishers/search", {
                            searchParams: searchParams,
                            headers: getHeaders(),
                        })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error("Search agency publishers error: ".concat(response.statusText));
                    }
                    return [2 /*return*/, response.json()];
                case 2:
                    error_2 = _c.sent();
                    console.error("Search agency publishers error:", error_2);
                    return [2 /*return*/, { items: [], totalRecords: 0 }];
                case 3: return [2 /*return*/];
            }
        });
    });
};
export var fetchAgencyPublisherBySourceId = function (kyInstance, sourceId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("agency-publishers/by-source-id/".concat(encodeURIComponent(sourceId)), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch agency publisher by source ID error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_3 = _a.sent();
                console.error("Error fetching agency publisher by source ID:", error_3);
                throw error_3;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchAgencyPublisherById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("agency-publishers/".concat(encodeURIComponent(id)), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch agency publisher by ID error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_4 = _a.sent();
                console.error("Error fetching agency publisher by ID:", error_4);
                throw error_4;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchPublisherBySourceId = function (kyInstance, sourceId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("publishers/".concat(encodeURIComponent(sourceId)), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch publisher by source ID error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_5 = _a.sent();
                console.error("Error fetching publisher by source ID:", error_5);
                throw error_5;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchAgencyPublisherPrefixHistory = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get("agency-publishers/".concat(encodeURIComponent(id), "/prefix-history"), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch agency publisher prefix history error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_6 = _a.sent();
                console.error("Error fetching agency publisher prefix history:", error_6);
                return [2 /*return*/, { items: [], totalRecords: 0 }];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchAgencyPublisherGenericProductNumbers = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var items, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetchAllPages(function (offset, limit) { return __awaiter(void 0, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, kyInstance.get(agencyPublishersIdGenericProductNumbers(id), { headers: getHeaders(), searchParams: { offset: offset, limit: limit } })];
                                case 1:
                                    response = _a.sent();
                                    if (!response.ok) {
                                        throw new Error("Fetch agency publisher generic product numbers error: ".concat(response.statusText));
                                    }
                                    return [4 /*yield*/, response.json()];
                                case 2: return [2 /*return*/, (_a.sent())];
                            }
                        });
                    }); })];
            case 1:
                items = _a.sent();
                return [2 /*return*/, { items: items, totalRecords: items.length }];
            case 2:
                error_7 = _a.sent();
                console.error("Error fetching agency publisher generic product numbers:", error_7);
                return [2 /*return*/, { items: [], totalRecords: 0 }];
            case 3: return [2 /*return*/];
        }
    });
}); };
